import Swal from "sweetalert2";
import { PRIMARY, SECONDARY } from "../const/colors";

const SwalBlockRetiro = (verification) => {
  return Swal.fire({
    html:
      `<h2>¡VERIFICA TU CUENTA!</h2>` +
      `<p class="register-p verificar-p">Te recordamos que para poder retirar tus ganancias debes realizar el proceso de verificación de tu cuenta. Queremos brindarte la mayor seguridad que esté en nuestras manos para que recibas tus fondos lo mas pronto posible.
</p>` +
      `<p class='verificar-cuenta-small'>En caso de tener cualquier contratiempo por favor comunícate con nosotros a la dirección de correo electrónico:  <span class='yellow'>info@masterbets365.com</span> o por el chat en línea.</p>`,
    showCancelButton: true,
    confirmButtonText: "Verificar",
    cancelButtonText: "Salir",
    allowOutsideClick: false,
    background: SECONDARY,
    color: "#fff",
    confirmButtonColor: PRIMARY,
  }).then((result) => {
    if (result.isConfirmed) {
      verification()
    } else if (result.dismiss === Swal.DismissReason.cancel) {
    }
  });
};

export default SwalBlockRetiro;
